import { render, staticRenderFns } from "./SelectionGroup.vue?vue&type=template&id=4f966a80&lang=pug&"
import script from "./SelectionGroup.vue?vue&type=script&lang=js&"
export * from "./SelectionGroup.vue?vue&type=script&lang=js&"
import style0 from "./SelectionGroup.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports